import { render } from "./StatsWrapper.vue?vue&type=template&id=3c6b174d"
import script from "./StatsWrapper.vue?vue&type=script&lang=js"
export * from "./StatsWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__